import { notEmpty, removeAtMedia, theme } from "@product/scmp-sdk";

import type { ResponsiveVariants } from "~/lib/styles/responsive";

export const useResponsiveImage = (
  sources: { url?: string; width: number }[],
  responsiveVariant: ResponsiveVariants<{
    aspectRatio: string;
    width: number;
  }>,
) => {
  const sourceSet = sources
    .map(source => (source.url ? `${source.url} ${source.width}w` : undefined))
    .filter(notEmpty)
    .join(", ");

  const viewportSizeKeyMap = [
    { key: "desktopUp", value: theme.breakpoints.up("desktop") },
    { key: "tabletUp", value: theme.breakpoints.up("tablet") },
    { key: "mobileUp", value: theme.breakpoints.up("mobile") },
  ] as const;

  const sizes = viewportSizeKeyMap
    .map(keyMap => `${removeAtMedia(keyMap.value)} ${responsiveVariant[keyMap.key].width}px`)
    .join(", ");

  return {
    bindResponsiveAspectRatio: {
      $aspectRatio: responsiveVariant.mobileUp.aspectRatio,
      $aspectRatioDesktopUp: responsiveVariant.desktopUp.aspectRatio,
      $aspectRatioTabletUp: responsiveVariant.tabletUp.aspectRatio,
    },
    bindResponsiveImage: {
      sizes,
      srcSet: sourceSet,
    },
  };
};
